/* DON'T EDIT THIS FILE: edit original and run build again */ import { promisePipe } from "../../framework/data-pipe/promise-pipe.ts";
import { usePipe } from "../../framework/firebase/use-pipe.ts";
import { fetchTenantIndex } from "../../framework/tenant-collection/tenant-index-entry.ts";

const createFetchTenantIndexPromisePipe = () => {
  return promisePipe(fetchTenantIndex());
};

export const useFetchTenantIndex = () => {
  return usePipe(createFetchTenantIndexPromisePipe, []);
};
